type Attachment = { name: string; size: number; uploadedAt: string };

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const pad = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

const formatUploadDate = (instant: string): string => {
  const d = new Date(instant);
  return Number.isNaN(d.getTime()) ? instant : `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
};

export const attachmentDetails = (attachment: Attachment): string =>
  `${formatFileSize(attachment.size)} · ${formatUploadDate(attachment.uploadedAt)}`;

export const distinguishableName = (attachment: Attachment, among: Attachment[]): string =>
  among.filter((other) => other.name === attachment.name).length > 1
    ? `${attachment.name} · ${attachmentDetails(attachment)}`
    : attachment.name;
